'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function ILFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-ddbddxl56", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-5ytm8zebx", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-cnv4a6eox" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-cnv4a6eox", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-ddbddxl56)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-cnv4a6eox" }), /* @__PURE__ */ React.createElement("g", { fill: "#3d58db" }, /* @__PURE__ */ React.createElement("path", { d: "M0 3h32v3H0zm0 15h32v3H0z", mask: "url(#mantine-5ytm8zebx)" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M13.02 13.93h6.133l-3.046-5.47zm7.738 1.009h-9.377l4.735-8.319z",
        mask: "url(#mantine-5ytm8zebx)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M13.051 16.188h5.994l-2.936-5.482zm7.63.973h-9.417l4.872-8.085z",
        mask: "url(#mantine-5ytm8zebx)",
        transform: "matrix(1 0 0 -1 0 26.238)"
      }
    ))))
  );
}

export { ILFlag };
//# sourceMappingURL=IL.mjs.map
